/* eslint-disable max-len */
import { FunctionComponent as F, useEffect, useState } from 'react';
import Subtitle from '../components/UI/Text/Subtitle';
import {
  Table as MaUTable,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
  Container } from '@mui/material';
import { getPriceUpdateStatus } from '../core/http/listing';
import { IPriceUpdateStatus, IPriceUpdateStatusRow, IPriceUpdateStatuses } from '../core/types/priceUpdateStatus';
import TextTooltip from '../components/UI/Tooltip/TextTooltip';



const PriceUpdateStatus: F = () =>
{
  const [priceUpdateStatuses, setPriceScrapeStatuses] = useState<IPriceUpdateStatuses | undefined>(undefined);

  useEffect(() =>
  {
    (async() => setPriceScrapeStatuses(await getPriceUpdateStatus() || undefined))();
  }, []);

  if(!priceUpdateStatuses)
    return <></>;

  const headings = [
    {
      heading: 'Vimergy Listings',
      value: 'vimergyListings',
      tooltip: 'Vimergy listings in the database from all vendors' },
    {
      heading: 'All Listings',
      value: 'listings',
      tooltip: 'All listings in the database' },
    {
      heading: 'All protocol listings',
      value: 'doseListings',
      tooltip: 'Listings in all users\' protocols' } ];

  if(priceUpdateStatuses?.userDosingListings.n)
  {
    headings.push({
      heading: 'Your protocol listings',
      value: 'userDosingListings',
      tooltip: 'Listings in your protocols' });
  }

  const rows: { [x: string]: IPriceUpdateStatusRow } = {};
  Object.keys(priceUpdateStatuses.listings).forEach(p =>
  {
    rows[p] = { vimergyListings: 0, userDosingListings: 0, listings: 0, doseListings: 0 };

    Object.keys(priceUpdateStatuses).forEach(l =>
    {
      rows[p][l as keyof IPriceUpdateStatusRow] = priceUpdateStatuses[l as keyof IPriceUpdateStatuses][p as keyof IPriceUpdateStatus];
    });
  });

  const Row = (title: string, priceUpdateStatusesWithinPeriod: IPriceUpdateStatusRow) => (
    <TableRow>
      <TableCell key={0}>{title}</TableCell>
      {headings.map((h, i) =>
      {
        // @ts-ignore
        const withinPeriod = priceUpdateStatusesWithinPeriod[h.value];
        // @ts-ignore
        const total = priceUpdateStatuses[h.value].n;

        return (
          <TableCell key={i + 1}>
            {withinPeriod + (total ? " (" + (withinPeriod / total * 100).toFixed(1) + " %)" : "")}
          </TableCell>);
      })}
    </TableRow>);

  return (
    // @ts-ignore
    <Container width='100%'>
      <Stack spacing={2}>

        <Subtitle>Price update status</Subtitle>

        <MaUTable size='small' id='PriceScrapeStatusTable'>
          <TableHead>
            <TableRow>
              <TableCell key={0}>Price updated within</TableCell>
              {headings.map((h, i) =>
                <TextTooltip key={i} tooltipPlacement='top' lines={[h.tooltip]}>
                  <TableCell key={i + 1}>
                    {h.heading}
                  </TableCell>
                </TextTooltip>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {Row("One day", rows.oneDay)}
            {Row("Two days", rows.twoDays)}
            {Row("One week", rows.oneWeek)}
            {Row("One month", rows.oneMonth)}
          </TableBody>
        </MaUTable>

      </Stack>
    </Container>);
};

export default PriceUpdateStatus;
